import React, { useEffect, useRef } from 'react';

const PdfCDNViewer = ({ url }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const loadPdf = async () => {
      try {
        console.log('📥 Loading PDF...');
        // Dynamically load the module from CDN
        const pdfjsLib = await import('https://mozilla.github.io/pdf.js/build/pdf.mjs');

        // Set worker path (also from CDN)
        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://mozilla.github.io/pdf.js/build/pdf.worker.mjs';

        // Load the PDF
        const loadingTask = pdfjsLib.getDocument(url);
        const pdf = await loadingTask.promise;

        console.log('✅ PDF loaded');

        // Get the first page
        const page = await pdf.getPage(1);
        console.log('📄 Page loaded');

        const scale = 1.5;
        const viewport = page.getViewport({ scale });

        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: context,
          viewport: viewport,
        };

        const renderTask = page.render(renderContext);
        await renderTask.promise;
        console.log('🎨 Page rendered');
      } catch (err) {
        console.error('❌ Error loading PDF:', err);
      }
    };

    loadPdf();
  }, [url]);

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-2">PDF Viewer</h2>
      <canvas ref={canvasRef} id="the-canvas" className="border rounded shadow" />
    </div>
  );
};

export default PdfCDNViewer;
